module.exports = __webpack_public_path__ + "img/star-full.3a8d495f.svg";